// extracted by mini-css-extract-plugin
export default {"container":"List_container__17wBr","listContainer":"List_listContainer__Zz23I","list":"List_list__PmUTO","promoContainer":"List_promoContainer__k-ivo","space":"List_space__SWM6j"};